<template>
  <footer class="footer">
    <div class="footer__inner">
      <div class="footer__grid">
        <!-- 品牌 -->
        <div class="footer__brand">
          <img
            class="footer__logo"
            src="../../assets/images/logo-white.png"
            alt="logo"
          />
          <p class="footer__brand-desc">
            {{ config.appName }}致力于通过技术赋能教育，连接全球优质教育资源，为学习者提供高效、便捷的在线学习体验。
          </p>
          <div class="footer__qrcodes">
            <div class="footer__qrcode-item">
              <img :src="wechatQrcode" alt="" />
              <span>公众号</span>
            </div>
            <div class="footer__qrcode-item">
              <img :src="xiaohongshuQrcode" alt="" />
              <span>小红书</span>
            </div>
          </div>
        </div>

        <!-- 平台服务 -->
        <div class="footer__links">
          <h4 class="footer__links-title">平台服务</h4>
          <ul class="footer__links-list">
            <li v-for="item in webInfo" :key="item.title">
              <a :href="item.url" target="_blank">
                <span class="footer__dot"></span>
                {{ item.title }}
              </a>
            </li>
          </ul>
        </div>

        <!-- 协议相关 -->
        <div class="footer__links">
          <h4 class="footer__links-title">协议相关</h4>
          <ul class="footer__links-list">
            <li v-for="item in protocolList" :key="item.title">
              <a :href="item.url" target="_blank">
                <span class="footer__dot"></span>
                {{ item.title }}
              </a>
            </li>
          </ul>
        </div>

        <!-- 联系方式 -->
        <div class="footer__contact">
          <h4 class="footer__links-title">联系我们</h4>
          <ul class="footer__contact-list">
            <li class="footer__contact-item">
              <div class="footer__contact-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
              </div>
              <a href="tel:400-628-2024">400-628-2024</a>
            </li>
            <li class="footer__contact-item">
              <div class="footer__contact-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
              </div>
              <a href="mailto:service@moguoyunke.com">service@moguoyunke.com</a>
            </li>
            <li class="footer__contact-item">
              <div class="footer__contact-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
              </div>
              <span>北京市朝阳区来广营西路国创产业园6号楼E门5层5001</span>
            </li>
          </ul>
        </div>
      </div>

      <!-- 底部版权栏 -->
      <div class="footer__bottom">
        <p class="footer__copyright">
          <span class="footer__copyright-item">
            Copyright &copy; {{ year }} {{ company }}
          </span>
          <a class="footer__copyright-item" href="https://beian.miit.gov.cn/" target="_blank">{{
            beian
          }}</a>
          <a
            class="footer__copyright-item"
            :href="
              'https://beian.mps.gov.cn/#/query/webSearch?code=' + config.recordCode
            "
            rel="noreferrer"
            target="_blank"
          >
            <img
              class="footer__record-icon"
              src="@/assets/img/record-icon.png"
              alt=""
            />京公网安备 {{ config.recordCode }}号</a
          >
          <a
            class="footer__copyright-item"
            target="_blank"
            href="https://tsm.miit.gov.cn/dxxzsp/ "
            >增值电信业务经营许可证：{{ config.licence }}</a
          >
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
import config from "@saas/components/src/config/company.json";
import { getCdnUrl } from "@saas/components/src/utils/assets";
export default {
  name: "CommonFooter",
  data() {
    return {
      year: new Date().getFullYear(),
      config: config,
      beian: config.beian,
      company: config.company,
      wechatQrcode: getCdnUrl("/image/web_assets/qrcode_for_gh_d94af974800d_430_3.png"),
      xiaohongshuQrcode: getCdnUrl("/cdn/org/settled/xiao-hong-shu-qrcode.png"),
      webInfo: [
        {
          title: "关于我们",
          url: "/about",
        },
        {
          title: "联系我们",
          url: "/contact",
        },
        {
          title: "软件下载",
          url: "/download",
        },
      ],
      protocolList: [
        {
          title: "用户协议",
          url: "/service-agreement",
        },
        {
          title: "隐私协议",
          url: getCdnUrl("/cdn/static/privacy-policy.html"),
        },
        {
          title: "机构服务协议",
          url: "/org-cooperate",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.footer {
  background-color: #0f172a;
  width: 100%;
  color: #94a3b8;
  border-radius: 3rem 3rem 0 0;
  margin-top: 40px;

  .footer__inner {
    max-width: 1280px;
    margin: 0 auto;
    padding: 60px 24px 40px;

    @media (min-width: 768px) {
      padding: 80px 32px 40px;
    }
  }

  .footer__grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 40px;
    margin-bottom: 48px;

    @media (min-width: 768px) {
      grid-template-columns: repeat(2, 1fr);
      gap: 48px;
    }

    @media (min-width: 1024px) {
      grid-template-columns: 1.5fr 1fr 1fr 1.2fr;
    }
  }

  // 品牌区域
  .footer__brand {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .footer__logo {
    width: 120px;
    filter: none;
    opacity: 0.9;
  }

  .footer__brand-desc {
    font-size: 14px;
    line-height: 1.7;
    color: #94a3b8;
  }

  .footer__qrcodes {
    display: flex;
    gap: 16px;
    margin-top: 8px;
  }

  .footer__qrcode-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;

    img {
      width: 72px;
      height: 72px;
      border-radius: 12px;
      border: 1px solid rgba(255, 255, 255, 0.1);
    }

    span {
      font-size: 11px;
      color: #64748b;
    }
  }

  // 链接区域
  .footer__links-title {
    font-weight: 700;
    font-size: 16px;
    color: #fff;
    margin-bottom: 20px;

    @media (min-width: 768px) {
      font-size: 18px;
      margin-bottom: 24px;
    }
  }

  .footer__links-list {
    display: flex;
    flex-direction: column;
    gap: 12px;

    a {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 14px;
      color: #94a3b8;
      transition: color 0.2s;
      text-decoration: none;

      &:hover {
        color: #34d399;
      }
    }
  }

  .footer__dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #10b981;
    flex-shrink: 0;
  }

  // 联系方式
  .footer__contact-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .footer__contact-item {
    display: flex;
    align-items: flex-start;
    gap: 12px;

    a, span {
      font-size: 14px;
      color: #94a3b8;
      margin-top: 4px;
      text-decoration: none;
      transition: color 0.2s;
    }

    a:hover {
      color: #34d399;
    }
  }

  .footer__contact-icon {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: #1e293b;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #10b981;
    flex-shrink: 0;
    transition: all 0.2s;
  }

  .footer__contact-item:hover .footer__contact-icon {
    background: #10b981;
    color: #fff;
  }

  // 底部版权栏
  .footer__bottom {
    border-top: 1px solid #1e293b;
    padding-top: 32px;
  }

  .footer__copyright {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 8px 32px;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.3);
  }

  .footer__copyright-item {
    display: flex;
    align-items: center;
    color: rgba(255, 255, 255, 0.3);
    text-decoration: none;
    transition: color 0.2s;

    &:hover {
      color: rgba(255, 255, 255, 0.6);
    }
  }

  .footer__record-icon {
    width: 14px;
    height: auto;
    margin-right: 4px;
  }
}

// h5 响应式
@media (max-width: 767px) {
  .footer {
    border-radius: 1rem 1rem 0 0;
    margin-top: 20px;
    overflow: hidden;

    .footer__inner {
      padding: 32px 16px 24px;
    }

    .footer__grid {
      gap: 24px;
    }

    .footer__brand-desc {
      font-size: 12px;
    }

    .footer__qrcode-item img {
      width: 56px;
      height: 56px;
    }

    .footer__links {
      .footer__links-title {
        font-size: 14px;
        margin-bottom: 12px;
      }

      .footer__links-list {
        flex-direction: row;
        flex-wrap: wrap;
        gap: 8px 16px;

        a {
          font-size: 13px;
        }
      }
    }

    .footer__contact-list {
      gap: 12px;
    }

    .footer__copyright {
      flex-direction: column;
      align-items: center;
      gap: 4px;

      .footer__copyright-item {
        cursor: default;
      }
    }
  }
}
</style>
